"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExecutorInitTemplate = getExecutorInitTemplate;
exports.getExceptionHandlerLogicTemplate = getExceptionHandlerLogicTemplate;
exports.getFunctionNameBindingTemplate = getFunctionNameBindingTemplate;
function getExecutorInitTemplate() {
    return `                let bc = _getBytecode(bytecodeId);
                let stack = [];
                // Local variables array (for non-captured variables)
                let locals = new Array((bc.p || 0) + (bc.l || 0));
                let pc = 0;
                let constants = bc.c;
                let instructions = bc.i;
                let opMap = {vmOpcodeMapName};

                // Exception handler stack
                // Each handler stores: { catchIndex, finallyIndex, endIndex, stackSize, pendingException, pendingReturn }
                let exceptionHandlers = [];

                // Pending exception to re-throw after finally block
                let pendingException = null;

                // Pending return value and flag
                let pendingReturn = { hasReturn: false, value: undefined };

                // Pending break/continue target (for try-finally)
                let pendingBreak = { hasBreak: false, target: 0 };
                let pendingContinue = { hasContinue: false, target: 0 };

                // Create environment for this function execution
                // Environment holds captured variables that need reference semantics
                let env = {
                    parent: parentEnv,
                    vars: {}
                };

                // Initialize parameters as locals
                if (args) {
                    for (let _loopIdx = 0; _loopIdx < Math.min(args.length, bc.p || 0); _loopIdx++) {
                        locals[_loopIdx] = args[_loopIdx];
                    }
                }`;
}
function getExceptionHandlerLogicTemplate() {
    return `                    // Exception was thrown during instruction execution
                    // Search for an exception handler
                    if (exceptionHandlers.length > 0) {
                        // Get the most recent exception handler
                        // Don't pop it yet if there's a finally block to execute
                        let handler = exceptionHandlers[exceptionHandlers.length - 1];

                        // Restore stack to the state when try block started
                        stack.length = handler.stackSize;

                        // Jump to catch handler if it exists, otherwise jump to finally
                        if (handler.catchIndex !== undefined) {
                            // Push the exception onto stack (will be stored by CATCH_START)
                            stack.push(exception);
                            pc = handler.catchIndex;
                            // Clear catchIndex so next exception goes to finally
                            // This handles exceptions thrown from within the catch block
                            handler.catchIndex = undefined;
                            // If there's a finally block, keep handler for potential re-throw from catch
                            if (handler.finallyIndex === undefined) {
                                // No finally block, pop the handler
                                exceptionHandlers.pop();
                            }
                        } else if (handler.finallyIndex !== undefined) {
                            pc = handler.finallyIndex;
                            // Store the exception as pending - it will be re-thrown after finally
                            handler.pendingException = exception;
                            // Don't pop handler yet - FINALLY_START will do it
                        } else {
                            // No catch or finally, jump to end
                            pc = handler.endIndex;
                            exceptionHandlers.pop();
                        }

                        // Re-enter the execution loop - continue from catch/finally handler
                        // Since we're now outside the while loop (caught by outer try-catch),
                        // we need to recursively re-enter the execution
                        // This is safe because we've updated pc to the catch/finally handler
                        continue;
                    }

                    // No exception handler found - re-throw to JavaScript
                    throw exception;`;
}
function getFunctionNameBindingTemplate() {
    return `                // Bind function name for named function expressions
                // Named function expressions have their name visible inside the function scope
                // We bind it to env.vars so it's available for recursive calls
                if (bc.ni !== undefined && currentFunc) {
                    const funcName = bc.c[bc.ni];
                    env.vars[funcName] = currentFunc;
                    // Mark as const so it can't be reassigned
                    if (!env.constVars) {
                        env.constVars = {};
                    }
                    env.constVars[funcName] = true;
                    // Set the function's .name property for introspection
                    // This allows constructor.name and function.name to work correctly
                    try {
                        Object.defineProperty(currentFunc, 'name', {
                            value: funcName,
                            writable: false,
                            enumerable: false,
                            configurable: true
                        });
                    } catch (e) {
                        // Ignore errors if name property can't be set
                    }
                }`;
}
